const conjunctionQuestions = [
  {
    id: 1,
    koreanQuestion:
      "공장은 중단해야 했다 운영을 임시로 심각한 부족______ 원재료의",
    question:
      "The factory had to suspend operations temporarily ______ a severe shortage of raw materials.",
    choices: {
      A: "in case of",
      B: "owing to",
      C: "despite",
      D: "instead of",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\nA: in case of는 '만약 ~할 경우에 대비하여'의 의미로 원인과 관련이 없음\nB: owing to는 '~때문에'의 의미로 원인을 나타내는데 적절\nC: despite는 '그럼에도 불구하고'의 의미로 반대되는 상황을 나타내므로 부적절\nD: instead of는 '~대신에'의 의미로 원인을 나타낼 수 없음\n\n✅ owing to 사용:\n- 원인이나 이유를 나타내는 전치사구로 적절\n- '~로 인해, ~때문에'의 의미",
    translation:
      "공장은 원자재의 심각한 부족으로 인해 임시로 운영을 중단해야 했다.",
    type: "preposition of cause",
  },

  {
    id: 2,
    koreanQuestion:
      "이사회 회의는 연기되었다 예기치 않은 상황 _____  영향을 미치며 주요 이해관계자에게",
    question:
      "The board meeting was postponed ______ unforeseen circumstances affecting key stakeholders.",
    choices: {
      A: "apart from",
      B: "on account of",
      C: "contrary to",
      D: "aside from",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\nA: apart from은 '~을 제외하고'의 의미로 원인과 관련이 없음\nB: on account of는 '~때문에'의 의미로 원인을 나타내는데 적절\nC: contrary to는 '~와 반대로'의 의미로 원인을 나타낼 수 없음\nD: aside from은 '~외에도'의 의미로 원인을 설명하는데 부적절\n\n✅ on account of 사용:\n- 원인이나 이유를 나타내는 전치사구로 적절\n- '~로 인해, ~때문에'의 의미",
    translation:
      "이사회 회의는 주요 이해관계자에게 영향을 미친 예기치 않은 상황으로 인해 연기되었다.",
    type: "preposition of cause",
  },
  {
    id: 3,
    koreanQuestion:
      "효과적인 협업은 여러 부서___  필수적이다 보장하는데 원활한 업무 흐름 통합을",
    question:
      "Effective collaboration ______ multiple departments is essential for ensuring seamless workflow integration.",
    choices: {
      A: "along",
      B: "between",
      C: "among",
      D: "within",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\nA: along은 '~을 따라서'의 의미로 부서 간 협업을 나타내기에 부적절\nB: between은 두 개 사이의 관계를 나타내므로 여러 부서에 사용 불가\nC: among은 셋 이상의 관계를 나타내는데 적절\nD: within은 '~내부에서'의 의미로 부서 간 협업을 나타내기에 부적절\n\n✅ among 사용:\n- 셋 이상의 대상 사이의 관계를 나타내는 전치사로 적절\n- 'multiple departments'는 여러 부서를 의미하므로 among 사용",
    translation:
      "여러 부서 간의 효과적인 협업은 원활한 업무 흐름 통합을 보장하는 데 필수적이다.",
    type: "preposition of relation",
  },
  {
    id: 4,
    koreanQuestion:
      "협상은 두 개의 선도적인 제약회사_____ 결과를 냈다 획기적인 합병 계약으로",
    question:
      "The negotiation ______ the two leading pharmaceutical companies resulted in a groundbreaking merger agreement.",
    choices: {
      A: "amid",
      B: "among",
      C: "between",
      D: "beyond",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\nA: amid는 '가운데에서'의 의미로 협상 대상이 아닌 상황이나 환경을 의미할 때 사용되므로 부적절\nB: among은 셋 이상의 관계를 나타내므로 두 회사 사이의 관계에 부적절\nC: between은 두 대상 사이의 관계를 나타내는데 적절\nD: beyond는 '~을 넘어서'의 의미로 회사 간 협상을 나타내기에 부적절\n\n✅ between 사용:\n- 두 대상 사이의 관계를 나타내는 전치사로 적절\n- 'two companies'는 두 회사를 의미하므로 between 사용",
    translation:
      "두 개의 선도적인 제약회사 간의 협상은 획기적인 합병 계약으로 이어졌다.",
    type: "preposition of relation",
  },
  {
    id: 5,
    koreanQuestion:
      "새로운 정책은 제공한다 여러 가지 인센티브를,  금전적 보너스___ , 직원들에게 그... 초과한 그들의 성과 목표를",
    question:
      "The new policy offers several incentives, ______ financial bonuses, to employees who exceed their performance targets.",
    choices: {
      A: "beside",
      B: "besides",
      C: "apart from",
      D: "except",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\nA: beside는 '~옆에'라는 물리적 위치를 나타내므로 부적절\nB: besides는 '~외에도'의 의미로 추가적인 항목을 나열할 때 적절\nC: apart from은 '~을 제외하고'의 의미로 포함의 의미와 반대\nD: except는 '~을 제외하고'의 의미로 포함의 의미와 반대\n\n✅ besides 사용:\n- '~외에도, ~이외에도'의 의미로 추가적인 항목을 나열할 때 사용\n- 여러 인센티브 중 하나로 금전적 보너스를 포함한다는 의미",
    translation:
      "새로운 정책은 성과 목표를 초과 달성한 직원들에게 금전적 보너스 외에도 여러 가지 인센티브를 제공한다.",
    type: "preposition of addition",
  },
  {
    id: 6,
    koreanQuestion:
      "부사장은 했다 개회연설을 CEO _____,  그... 참석하지 못한 연례 주주총회에 예기치 못한 긴급 상황으로 인해",
    question:
      "The vice president delivered an opening speech ______ the CEO, who was unable to attend the annual shareholders' meeting due to an unforeseen emergency.",
    choices: {
      A: "in addition to",
      B: "on behalf of",
      C: "in charge of",
      D: "regardless of",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\nA: in addition to는 '~에 더하여'라는 의미로 CEO가 불참한 상황과 맞지 않음\nB: on behalf of는 '~를 대신하여'라는 의미로 가장 적절\nC: in charge of는 '~을 담당하는'이라는 의미로 대리 연설의 의미와 다름\nD: regardless of는 '~에 상관없이'라는 의미로 대체 관계를 나타내지 못함\n\n✅ on behalf of 사용:\n- '~를 대신하여'라는 의미로 누군가를 대신해 행동할 때 사용\n- CEO가 불참한 상황에서 부사장이 대신 연설한다는 맥락에 적절",
    translation:
      "부사장은 예기치 못한 긴급 상황으로 인해 연례 주주총회에 참석하지 못한 CEO를 대신하여 개회 연설을 했다.",
    type: "preposition of representation",
  },

  {
    id: 7,
    koreanQuestion:
      "나는 전적으로 동의한다 이사의 결정____ 도입하기 위해 하이브리드 근무 모델을 모든 직원에게",
    question:
      "I completely agree ______ the director's decision to implement a hybrid work model for all employees.",
    choices: {
      A: "with",
      B: "to",
      C: "on",
      D: "for",
    },
    correctAnswer: "A",
    explanation:
      "설명:\n\nA: agree with는 '~에 동의하다'의 의미로 가장 적절\nB: agree to는 '제안/계획에 동의하다'의 의미로 사람이 올 수 없음\nC: agree on은 '의견/주제에 대해 동의하다'의 의미로 부적절\nD: for는 '동의하다'의 의미로 사용되지 않음\n\n✅ agree with 사용:\n- '~에 동의하다'라는 의미로 사람이나 의견에 동의할 때 사용\n- 'the director's decision'이라는 의견/결정에 동의하는 맥락에 적절",
    translation:
      "나는 모든 직원에게 하이브리드 근무 모델을 도입하겠다는 이사의 결정에 전적으로 동의한다.",
    type: "preposition with verb",
  },
  {
    id: 8,
    koreanQuestion:
      "위원회 위원들은 망설였다 동의하는 것을 CEO와____ 제안된 예산 삭감안에 대해",
    question:
      "The committee members were hesitant to agree ______ the CEO about the proposed budget cuts.",
    choices: {
      A: "on",
      B: "with",
      C: "to",
      D: "about",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\nA: agree on은 '의견/주제에 대해 동의하다'의 의미로 사람과 함께 쓰지 않음\nB: agree with는 '~와 동의하다'의 의미로 사람과 함께 쓸 때 가장 적절\nC: agree to는 '제안/계획에 동의하다'의 의미로 사람과 함께 쓸 수 없음\nD: agree about는 일반적으로 잘 쓰이지 않는 표현\n\n✅ agree with 사용:\n- '~와 동의하다'라는 의미로 사람과 함께 쓸 때 적절\n- CEO라는 사람과 함께 쓰이는 맥락에서 적절",
    translation:
      "위원회 위원들은 제안된 예산 삭감안에 대해 CEO와 동의하는 것을 망설였다.",
    type: "preposition with verb",
  },
  {
    id: 9,
    koreanQuestion: "두 임원은 못했다 동의를 그들의 접근____ 개편하는 조직을",
    question:
      "The two executives failed to agree ______ their approach to restructuring the organization.",
    choices: {
      A: "to",
      B: "on",
      C: "with",
      D: "for",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\nA: agree to는 '제안/계획에 동의하다'의 의미로 사람과 함께 쓸 수 없음\nB: agree on은 '의견/주제에 대해 동의하다'의 의미로 사람과 함께 쓰지 않음\nC: agree with는 '~와 동의하다'의 의미로 사람과 함께 쓸 때 가장 적절\nD: for는 '동의하다'의 의미로 사용되지 않음\n\n✅ agree with 사용:\n- '~와 동의하다'라는 의미로 사람과 함께 쓸 때 적절\n- 두 임원이 서로 동의하지 못한다는 맥락에서 적절",
    translation: "두 임원은 조직 개편 접근 방식에 대해 서로 동의하지 못했다.",
    type: "preposition with verb",
  },
  {
    id: 10,
    koreanQuestion:
      "법무팀은 우려를 제기했다 새로 시행된 데이터 프라이버시 정책____, 언급하며 잠재적인 규정 준수 위험을 ",
    question:
      "The legal department has raised concerns ______ the newly implemented data privacy policy, citing potential compliance risks.",
    choices: {
      A: "with respect to",
      B: "in spite of",
      C: "in line with",
      D: "regardless of",
    },
    correctAnswer: "A",
    explanation:
      "설명:\n\nA: with respect to는 '~에 관하여'의 의미로 우려 사항의 대상을 나타내는데 적절\nB: in spite of는 '~에도 불구하고'의 의미로 문맥상 부적절\nC: in line with는 '~와 일치하여'의 의미로 우려를 표현하는 맥락과 맞지 않음\nD: regardless of는 '~에 상관없이'의 의미로 우려 사항을 나타내는데 부적절\n\n✅ with respect to 사용:\n- '~에 관하여, ~에 대하여'라는 의미로 특정 주제나 사안을 언급할 때 사용\n- 공식적인 문맥에서 자주 사용되는 표현\n- 법무팀이 정책에 대한 우려를 제기하는 상황에 적절",
    translation:
      "법무팀은 잠재적인 규정 준수 위험을 언급하며 새로 시행된 데이터 프라이버시 정책에 관하여 우려를 제기했다.",
    type: "preposition phrase",
  },

  {
    id: 11,
    koreanQuestion:
      "직원들은 요구된다 따르도록 비상 대책을 정전____ 보장하기 위해 업무장 안전을",
    question:
      "Employees are required to follow emergency protocols ______ a power outage to ensure workplace safety.",
    choices: {
      A: "in the event of",
      B: "by means of",
      C: "in compliance with",
      D: "with a view to",
    },
    correctAnswer: "A",
    explanation:
      "설명:\n\nA: in the event of는 '~의 경우에'라는 의미로 가상의 상황을 나타내는데 적절\nB: by means of는 '~을 이용하여'라는 의미로 비상 절차와 관련이 없음\nC: in compliance with는 '~을 준수하여'라는 의미로 절차를 따르는 것이 아닌 조건을 나타내는 문맥이라 부적절\nD: with a view to는 '~을 목적으로'라는 의미로 정전 발생을 대비하는 것이 아닌 조건이므로 부적절\n\n✅ in the event of 사용:\n- '~의 경우에'라는 의미로 특정 상황이 발생할 가능성을 나타낼 때 사용\n- 비상 상황이나 예기치 않은 상황을 가정할 때 적절한 표현",
    translation:
      "직원들은 정전이 발생할 경우 업무장 안전을 보장하기 위해 비상 대책을 따라야 한다.",
    type: "preposition phrase",
  },
  {
    id: 12,
    koreanQuestion:
      "예상치 못한 공급망 차질로 인해 , 합성 재료가 사용되었다 전통적인 원자재 ____  생산에서",
    question:
      "Due to unexpected supply chain disruptions, synthetic materials were used ______ traditional raw materials in production.",
    choices: {
      A: "in place of",
      B: "regardless of",
      C: "in the event of",
      D: "with respect to",
    },
    correctAnswer: "A",
    explanation:
      "설명:\n\nA: in place of는 '~대신에'의 의미로 대체 상황을 나타내는데 가장 적절\nB: regardless of는 '~에 상관없이'의 의미로 대체 개념이 아니라서 부적절\nC: in the event of는 '~의 경우에'의 의미로 대체의 의미가 아님\nD: with respect to는 '~에 관하여'의 의미로 대체를 의미하는 문맥이 아님\n\n✅ in place of 사용:\n- '~대신에'라는 의미로 한 것을 다른 것으로 대체할 때 사용\n- 원래 사용하던 것 대신 다른 것을 사용하는 상황에 적절한 표현",
    translation:
      "예상치 못한 공급망 차질로 인해 생산에서 전통적인 원자재 대신에 합성 재료가 사용되었다.",
    type: "preposition phrase",
  },
  {
    id: 13,
    koreanQuestion:
      "최근의 경제 침체____ , 회사는  시행했다 비용 절감 조치를 유지하기 위해 수익성을 ",
    question:
      "___ the recent economic downturn, the company has implemented cost-cutting measures to maintain profitability.",
    choices: {
      A: "as a consequence of",
      B: "in compliance with",
      C: "in line with",
      D: "instead of",
    },
    correctAnswer: "A",
    explanation:
      "설명:\n\nA: as a consequence of는 '~의 결과로'라는 의미로 원인과 결과를 연결하는데 가장 적절\nB: in compliance with는 '~을 준수하여'라는 의미로 원인과 결과를 연결하는 문맥이 아니라서 부적절\nC: in line with는 '~와 일치하여'라는 의미로 경제 침체와 정책이 일치하는 개념이 아님\nD: instead of는 '~대신에'라는 의미로 결과를 나타내는 문맥이 아님\n\n✅ as a consequence of 사용:\n- '~의 결과로'라는 의미로 원인과 결과 관계를 나타낼 때 사용\n- 특정 상황이나 행동의 직접적인 결과를 설명할 때 적절한 표현",
    translation:
      "최근의 경제 침체의 결과로, 회사는 수익성을 유지하기 위해 비용 절감 조치를 시행했다.",
    type: "preposition phrase",
  },
  {
    id: 14,
    koreanQuestion:
      "새로운 정책은 명시한다 그... 모든 직원들이 받을 것이라고 성과 보너스를 그들의 직책이나 근속 연수와 ____",
    question:
      "The new policy states that all employees will receive performance bonuses ___ their job titles or seniority.",
    choices: {
      A: "regardless of",
      B: "with respect to",
      C: "by means of",
      D: "in place of",
    },
    correctAnswer: "A",
    explanation:
      "설명:\n\nA: regardless of는 '~에 관계없이'라는 의미로 조건에 상관없는 상황을 나타내는데 가장 적절\nB: with respect to는 '~에 관하여'라는 의미로 차이를 무시하는 문맥과 맞지 않음\nC: by means of는 '~을 이용하여'라는 의미로 방법을 설명하는 것이 아님\nD: in place of는 '~대신에'라는 의미로 대체 개념이 아니므로 부적절\n\n✅ regardless of 사용:\n- '~에 관계없이'라는 의미로 어떤 조건이나 상황에 상관없이 결과가 동일할 때 사용\n- 차이나 조건을 고려하지 않고 동등하게 적용되는 상황을 나타낼 때 적절한 표현",
    translation:
      "새로운 정책에 따르면 모든 직원은 직책이나 근속 연수에 관계없이 성과 보너스를 받게 된다.",
    type: "preposition phrase",
  },
  {
    id: 15,
    koreanQuestion:
      "모든 직원은 제출해야 한다 그들의 비용보고서를 회사의 재무 정책___ 환급 처리가 되기 전에 ",
    question:
      "All employees must submit their expense reports _____ the company's financial policies before reimbursement can be processed.",
    choices: {
      A: "with regard to",
      B: "in compliance with",
      C: "in accordance with",
      D: "instead of",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\nA: with regard to는 '~에 관하여'라는 의미로 절차를 따르는 개념이 아니라서 부적절\nB: in compliance with는 '~을 준수하여'라는 의미로 일반적인 규정보다는 정책을 따르는 문맥에 부적절\nC: in accordance with는 '~에 따라'라는 의미로 정책이나 규정을 따르는 상황을 나타내는데 가장 적절\nD: instead of는 '~대신에'라는 의미로 문맥상 맞지 않음\n\n✅ in accordance with 사용:\n- '~에 따라'라는 의미로 규칙, 정책, 절차 등을 따르는 상황을 나타낼 때 사용\n- 공식적인 규정이나 정책을 준수하는 맥락에서 자주 사용되는 표현",
    translation:
      "모든 직원은 환급 처리가 되기 전에 회사의 재무 정책에 따라 비용 보고서를 제출해야 한다.",
    type: "preposition phrase",
  },
  {
    id: 16,
    koreanQuestion:
      "새로운 안전 지침은 도입되었다  국제 산업 규정___  보장하기 위해 작업장 안전을",
    question:
      "The new safety guidelines were introduced _______ international industry regulations to ensure workplace security.",
    choices: {
      A: "in reference to",
      B: "in accordance with",
      C: "in compliance with",
      D: "in place of",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\nA: in reference to는 '~에 관하여'라는 의미로 규정을 준수하는 문맥과 부적절\nB: in accordance with는 '~에 따라'라는 의미로 규정을 따르는 것보다 준수해야 한다는 뉘앑스가 강해야 함\nC: in compliance with는 '~을 준수하여'라는 의미로 규정이나 법규를 엄격히 따르는 상황을 나타내는데 가장 적절\nD: in place of는 '~대신에'라는 의미로 대체하는 개념이 아니므로 부적절\n\n✅ in compliance with 사용:\n- '~을 준수하여'라는 의미로 규정, 법규, 기준 등을 엄격히 따르는 상황을 나타낼 때 사용\n- 특히 공식적인 규정이나 법적 요구사항을 준수하는 맥락에서 자주 사용되는 표현",
    translation:
      "새로운 안전 지침은 국제 산업 규정을 준수하여 도입되었으며 작업장 안전을 보장하기 위한 것이다.",
    type: "preposition phrase",
  },

  {
    id: 17,
    koreanQuestion: "수정된 예산 배분은 회사의 장기 성장 전략______",
    question:
      "The revised budget allocations are ___ the company's long-term growth strategy.",
    choices: {
      A: "in the event of",
      B: "in reference to",
      C: "in line with",
      D: "regardless of",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\nA: in the event of는 '만약 ~할 경우'라는 의미로 조건을 나타내는 표현이라 부적절\nB: in reference to는 '~에 관하여'라는 의미로 일치를 나타내는 문맥과 맞지 않음\nC: in line with는 '~와 일치하여'라는 의미로 전략과의 일치성을 나타내는데 가장 적절\nD: regardless of는 '~에 상관없이'라는 의미로 문맥상 어울리지 않음\n\n✅ in line with 사용:\n- '~와 일치하여, ~에 부합하여'라는 의미로 정책, 전략, 목표 등과의 일치성을 나타낼 때 사용\n- 특히 조직의 방향성이나 계획과의 연계성을 강조할 때 자주 사용되는 표현",
    translation: "수정된 예산 배분은 회사의 장기 성장 전략과 일치한다.",
    type: "preposition phrase",
  },
  {
    id: 18,
    koreanQuestion:
      "새롭게 설계된 사무실 배치는 개발되었다 회사의 약속____  조성하며 협업 환경을",
    question:
      "The newly designed office layout was developed ___ the company's commitment to fostering a collaborative work environment.",
    choices: {
      A: "in compliance with",
      B: "with respect to",
      C: "in keeping with",
      D: "instead of",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\nA: in compliance with는 '~을 준수하여'라는 의미로 규정이나 법규를 따르는 상황에 사용되므로 부적절\nB: with respect to는 '~에 관하여'라는 의미로 부합하는 개념을 나타내는데 부적절\nC: in keeping with는 '~와 부합하여, ~에 맞게'라는 의미로 회사의 약속이나 방향성과 일치함을 나타내는데 가장 적절\nD: instead of는 '~대신에'라는 의미로 대체의 개념이 아니므로 부적절\n\n✅ in keeping with 사용:\n- '~와 부합하여, ~에 맞게'라는 의미로 정책, 가치, 목표 등과의 조화를 나타낼 때 사용\n- 특히 조직의 방향성이나 가치와의 일관성을 강조할 때 자주 사용되는 표현",
    translation:
      "새롭게 설계된 사무실 배치는 협업 환경을 조성하겠다는 회사의 약속에 부합하도록 개발되었다.",
    type: "preposition phrase",
  },
  {
    id: 19,
    koreanQuestion:
      "매니저는 제공했다 추가적인 정보를 다가오는 조정 ____ 영업 부서의 ",
    question:
      "The manager provided additional details ___ the upcoming restructuring of the sales department.",
    choices: {
      A: "in the event of",
      B: "in accordance with",
      C: "with regard to",
      D: "in compliance with",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\nA: in the event of는 '만약 ~할 경우'라는 의미로 상황을 설명하는 문맥과 맞지 않음\nB: in accordance with는 '~에 따라'라는 의미로 규정이나 정책과 관련된 표현이 아니므로 부적절\nC: with regard to는 '~에 관하여, ~와 관련하여'라는 의미로 특정 주제나 사안에 대해 언급할 때 가장 적절\nD: in compliance with는 '~을 준수하여'라는 의미로 정책이나 규정을 따르는 문맥이 아니므로 부적절\n\n✅ with regard to 사용:\n- '~에 관하여, ~와 관련하여'라는 의미로 특정 주제나 사안을 소개하거나 설명할 때 사용\n- 공식적인 상황에서 주제를 언급하거나 관련 정보를 제공할 때 자주 사용되는 표현",
    translation:
      "매니저는 다가오는 영업 부서 구조 조정과 관련하여 추가적인 정보를 제공했다.",
    type: "preposition phrase",
  },
  {
    id: 20,
    koreanQuestion:
      "(현재) 많은 문의가 있었다 변경 ____ 직원복지에 새로운 계약에 따라",
    question:
      "There have been numerous inquiries ___ the changes in employee benefits under the new contract.",
    choices: {
      A: "in line with",
      B: "in compliance with",
      C: "with respect to",
      D: "in place of",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\nA: in line with는 '~와 일치하여'라는 의미로 문의사항을 언급하는 문맥과 맞지 않음\nB: in compliance with는 '~을 준수하여'라는 의미로 규정 준수와 관련된 문맥이 아니므로 부적절\nC: with respect to는 '~에 관하여, ~와 관련하여'라는 의미로 특정 주제나 사안에 대한 문의를 나타내는데 가장 적절\nD: in place of는 '~대신에'라는 의미로 대체의 개념이 아니므로 부적절\n\n✅ with respect to 사용:\n- '~에 관하여, ~와 관련하여'라는 의미로 특정 주제나 사안을 언급할 때 사용\n- 공식적인 상황에서 주제를 소개하거나 관련 정보를 다룰 때 자주 사용되는 표현",
    translation:
      "새로운 계약에 따른 직원 복지 혜택 변경과 관련하여 많은 문의가 있었다.",
    type: "preposition phrase",
  },
  {
    id: 21,
    koreanQuestion:
      "이메일은 포함되있었다 중요한 업데이트를 최신 개정 ___  기업 세금 정책에",
    question:
      "The email contained critical updates ___ the latest amendments to the corporate tax policies.",
    choices: {
      A: "in accordance with",
      B: "regardless of",
      C: "in reference to",
      D: "instead of",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\nA: in accordance with는 '~에 따라'라는 의미로 단순히 정보를 언급하는 문맥과 맞지 않음\nB: regardless of는 '~에 상관없이'라는 의미로 관련성을 나타내는 문맥과 맞지 않음\nC: in reference to는 '~와 관련하여, ~에 대하여'라는 의미로 특정 주제에 대한 정보나 업데이트를 언급할 때 가장 적절\nD: instead of는 '~대신에'라는 의미로 대체의 개념이 아니므로 부적절\n\n✅ in reference to 사용:\n- '~와 관련하여, ~에 대하여'라는 의미로 특정 주제나 사안을 언급할 때 사용\n- 공식적인 문서나 이메일에서 주제를 소개하거나 관련 정보를 제공할 때 자주 사용되는 표현",
    translation:
      "이메일에는 최신 기업 세금 정책 개정과 관련된 중요한 업데이트가 포함되어 있었다.",
    type: "preposition phrase",
  },
  {
    id: 22,
    koreanQuestion:
      "새로운 기밀 유지 계약은 될 것이다 법적 구속력을 직원의 서명___ 서류에",
    question:
      "The new confidentiality agreement will become legally binding ___ the employee's signature on the document.",
    choices: {
      A: "with",
      B: "upon",
      C: "on",
      D: "after",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\nA: with는 '~와 함께'라는 의미로 문맥상 부적절\nB: upon은 '~하자마자, ~즉시'라는 의미로 서명과 동시에 효력이 발생함을 나타내는데 가장 적절\nC: on은 'on signature'의 형태로 사용될 때 자연스럽지 않으며, upon이 더 격식적이고 계약 문서에 적합\nD: after는 '~이후에'라는 의미로 즉각적인 효력 발생을 강조하는 문맥과 맞지 않음\n\n✅ upon 사용:\n- '~하자마자, ~즉시'라는 의미로 어떤 사건이나 행동이 발생하는 즉시를 나타낼 때 사용\n- 특히 법적 문서나 계약서에서 조건이나 시점을 명시할 때 자주 사용되는 격식적인 표현",
    translation:
      "새로운 기밀 유지 계약은 직원이 문서에 서명하는 즉시 법적 효력을 갖게 될 것이다.",
    type: "preposition phrase",
  },

  {
    id: 23,
    koreanQuestion:
      " 증가된 운영 비용___, 회사는 또한 (현재) 투자 중이다 막대하게 연구와 개발에 유지하기 위해 경쟁력을",
    question:
      "___ the increased operational expenses, the company is also investing heavily in research and development to stay competitive.",
    choices: {
      A: "Regardless of",
      B: "Instead of",
      C: "Aside from",
      D: "Except for",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\nA: Regardless of는 '~에 상관없이'라는 의미로 운영 비용 증가와 연구개발 투자가 모두 발생하는 상황과 맞지 않음\nB: Instead of는 '~대신에'라는 의미로 두 활동이 동시에 진행되는 문맥과 맞지 않음\nC: Aside from은 '~외에도'라는 의미로 운영 비용 증가와 더불어 추가적인 연구개발 투자를 나타내는데 가장 적절\nD: Except for는 '~을 제외하고'라는 의미로 추가적인 상황을 나타내는 문맥과 맞지 않음\n\n✅ Aside from 사용:\n- '~외에도, ~이외에'라는 의미로 이미 언급된 것에 추가적인 요소나 상황을 나타낼 때 사용\n- 특히 비즈니스 상황에서 여러 활동이나 비용이 동시에 발생함을 설명할 때 자주 사용되는 표현",
    translation:
      "운영 비용 증가 외에도, 회사는 경쟁력을 유지하기 위해 연구개발에 막대한 투자를 하고 있다.",
    type: "preposition phrase",
  },
  {
    id: 24,
    koreanQuestion:
      "성공은 신제품 출시 우리의 초기 예상치 ____, 이끌며 큰 증가를 시장 점유율에서",
    question:
      "The success of the new product launch was ___ our initial projections, leading to a significant increase in market share.",
    choices: {
      A: "over",
      B: "beyond",
      C: "past",
      D: "above",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\nA: over는 '수치를 초과하다'라는 의미로 헷갈릴 수 있지만, 기대치/예상을 초과하는 표현에는 beyond가 적절\nB: beyond는 '~을 넘어서'라는 의미로 예상이나 기대치를 초과할 때 가장 적절한 표현\nC: past는 '지나서'라는 시간적 의미가 강하므로 부적절\nD: above는 '위에'라는 물리적 개념이 강하며, 기대치를 초과하는 의미로는 적절하지 않음\n\n✅ beyond 사용:\n- '~을 넘어서'라는 의미로 예상, 기대치, 한계 등을 초과할 때 사용\n- 특히 비즈니스 상황에서 목표나 예상치를 초과하는 성과를 설명할 때 자주 사용되는 표현",
    translation:
      "신제품 출시의 성공은 우리의 초기 예상치를 넘어섰으며, 시장 점유율이 크게 증가하는 결과를 가져왔다.",
    type: "preposition phrase",
  },
  {
    id: 25,
    koreanQuestion:
      "새로운 준수 지침은 시행될 것이다 모든 회사 지점____ 보장하기 위해 일관성을 운영에 있어",
    question:
      "The new compliance guidelines will be implemented ___ all company branches to ensure consistency in operations.",
    choices: {
      A: "across",
      B: "along",
      C: "throughout",
      D: "within",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\nA: across는 '가로질러'의 의미로 특정 위치를 넘는 개념에 적합하지만, '전체적으로 퍼진' 의미에는 throughout이 적절\nB: along은 '따라서'라는 의미로 문맥과 맞지 않음\nC: throughout은 '전반에 걸쳐, 도처에'라는 의미로 회사의 모든 지점에 걸쳐 시행됨을 나타내는데 가장 적절\nD: within은 '내부에서'라는 의미로 지점 전체를 아우르는 개념과 맞지 않음\n\n✅ throughout 사용:\n- '전반에 걸쳐, 도처에'라는 의미로 어떤 것이 전체적으로 퍼져있거나 적용됨을 나타낼 때 사용\n- 특히 정책이나 지침이 조직 전체에 적용됨을 설명할 때 자주 사용되는 표현",
    translation:
      "새로운 준수 지침은 모든 회사 지점 전반에 걸쳐 시행되어 운영의 일관성을 보장할 것이다.",
    type: "preposition phrase",
  },
  {
    id: 26,
    koreanQuestion:
      "회사는 (현재) 확장했다 회사의 시장 입지를 5개 다른 대륙 ___ 지난 10년 동안.",
    question:
      "The company has expanded its market presence ___ five different continents over the past decade.",
    choices: {
      A: "throughout",
      B: "across",
      C: "along",
      D: "beyond",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\nA: throughout는 '전체적으로 퍼져 있음'을 의미하므로 특정 지역을 넘나드는 개념과는 부적절\nB: across는 '가로질러, ~에 걸쳐'라는 의미로 여러 대륙에 걸친 지리적 확장을 나타내는데 가장 적절\nC: along은 '길을 따라'의 의미로 지역 확장과는 관련 없음\nD: beyond는 '초월하여'의 의미로 지역적 확장을 나타내는 문맥과 맞지 않음\n\n✅ across 사용:\n- '가로질러, ~에 걸쳐'라는 의미로 지리적 영역이나 경계를 넘어서는 확장을 나타낼 때 사용\n- 특히 비즈니스 상황에서 여러 지역이나 국가로의 확장을 설명할 때 자주 사용되는 표현",
    translation:
      "회사는 지난 10년 동안 다섯 개 대륙에 걸쳐 시장 입지를 확장했다.",
    type: "preposition phrase",
  },
  {
    id: 27,
    koreanQuestion:
      "도시는 (현재) 계획 중이다 건설할 일련의 친환경 공원을 강____ 촉진하기 위해 지속 가능한 도시 개발을.",
    question:
      "The city is planning to construct a series of eco-friendly parks ___ the river to promote sustainable urban development.",
    choices: {
      A: "across",
      B: "throughout",
      C: "along",
      D: "beyond",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\nA: across는 '가로질러'의 의미로 강을 넘는 것이 아니라 '따라서'의 의미이므로 부적절\nB: throughout는 '전체적으로'의 의미로 특정 선형 경로를 설명하는 문맥과 맞지 않음\nC: along은 '~을 따라서'라는 의미로 강변을 따라 공원이 건설됨을 나타내는데 가장 적절\nD: beyond는 '초월하여'라는 의미로 방향성을 나타내는 문맥과 부적절\n\n✅ along 사용:\n- '~을 따라서'라는 의미로 특정 선형 경로나 방향을 따라 무언가가 위치하거나 진행됨을 나타낼 때 사용\n- 특히 도로, 강, 해안선 등을 따라 무언가가 위치함을 설명할 때 자주 사용되는 표현",
    translation:
      "도시는 지속 가능한 도시 개발을 촉진하기 위해 강을 따라 일련의 친환경 공원을 건설할 계획이다.",
    type: "preposition phrase",
  },
  {
    id: 28,
    koreanQuestion:
      "최근 경제 침체____, 회사는 보고했다 큰 증가를 분기별 매출의  ",
    question:
      "___ the recent economic slowdown, the company reported a significant increase in quarterly revenue.",
    choices: {
      A: "Despite of",
      B: "Notwithstanding",
      C: "Regardless",
      D: "Contrary",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\nA: Despite of는 문법적으로 잘못된 표현으로, despite 뒤에는 전치사 of 없이 명사가 바로 와야 함\nB: Notwithstanding은 '~에도 불구하고'라는 의미로 역접의 상황을 나타내는데 가장 적절\nC: Regardless는 '상관없이'라는 의미로 문맥상 부적절\nD: Contrary는 '반대로'라는 의미로 문장 구조에 맞지 않음\n\n✅ Notwithstanding 사용:\n- '~에도 불구하고'라는 의미로 역접 관계를 나타낼 때 사용\n- Despite와 유사한 의미로 사용되며, 보다 격식있는 표현\n- 명사구나 절 앞에 위치하여 양보의 의미를 나타냄",
    translation:
      "최근 경제 침체에도 불구하고, 회사는 분기별 매출이 크게 증가했다고 보고했다.",
    type: "conjunction",
  },
  {
    id: 29,
    koreanQuestion:
      "매니저는 보냈다 이메일을 수정된 예산 배정들____ 다음 회계연도를 위한",
    question:
      "The manager sent an email ___ the revised budget allocations for the next fiscal year.",
    choices: {
      A: "in spite of",
      B: "regarding",
      C: "rather than",
      D: "alongside",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\nA: in spite of는 '~에도 불구하고'라는 의미로 정보 전달의 맥락과 맞지 않음\nB: regarding은 '~에 관하여'라는 의미로 예산 배정에 대한 정보를 전달하는 상황에 가장 적절\nC: rather than은 '~대신에'라는 의미로 단순 정보 전달 문맥과 부적절\nD: alongside는 '~와 함께'라는 의미로 예산 관련 정보 전달과 어울리지 않음\n\n✅ regarding 사용:\n- '~에 관하여, ~와 관련하여'라는 의미로 특정 주제나 사안에 대해 언급할 때 사용\n- 공식적인 의사소통에서 자주 사용되는 표현\n- 특히 업무적 맥락에서 특정 사안이나 주제를 소개할 때 적절",
    translation:
      "매니저는 다음 회계연도의 수정된 예산 배정과 관련하여 이메일을 보냈다.",
    type: "conjunction",
  },
  {
    id: 30,
    koreanQuestion: "직원들은 권리가 있다 20일을 유급휴가 회사 정책에 ___ .",
    question:
      "Employees are entitled to 20 days of paid leave ___ company policy.",
    choices: {
      A: "per",
      B: "via",
      C: "on behalf of",
      D: "concerning",
    },
    correctAnswer: "A",
    explanation:
      "설명:\n\nA: per는 '~에 따라'라는 의미로 회사 정책에 근거한 규정을 나타내는데 가장 적절\nB: via는 '경유하여, 통해서'라는 의미로 규정 준수를 의미하는 문맥과 맞지 않음\nC: on behalf of는 '대신하여'라는 의미로 규정이 아닌 대리 권한을 의미하므로 부적절\nD: concerning은 '관련하여'라는 의미로 규정 준수를 의미하는 문맥과 맞지 않음\n\n✅ per 사용:\n- '~당, ~에 따라'라는 의미로 규정, 정책, 기준에 따른 내용을 설명할 때 사용\n- 특히 공식적인 문서나 규정에서 자주 사용되는 표현\n- 단위나 기준을 나타내는 데 효과적",
    translation:
      "직원들은 회사 정책에 따라 20일의 유급 휴가를 받을 권리가 있다.",
    type: "preposition phrase",
  },
  {
    id: 31,
    koreanQuestion:
      "최종 결제는 반드시 처리되어야 합니다 전신 송금___ 3월 15일까지",
    question:
      "The final payment must be processed ___ wire transfer no later than March 15.",
    choices: {
      A: "per",
      B: "beyond",
      C: "via",
      D: "regarding",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\nA: per는 '~에 따라'라는 의미로 결제 방식을 설명하는데 부적절\nB: beyond는 '~을 넘어서'라는 의미로 결제 방식과 관련이 없음\nC: via는 '~을 통해'라는 의미로 전신 송금이라는 결제 방식을 나타내는데 가장 적절\nD: regarding은 '~에 관하여'라는 의미로 결제 방식을 설명하는 문맥과 맞지 않음\n\n✅ via 사용:\n- '~을 통해, ~을 경유하여'라는 의미로 특정 수단이나 경로를 나타낼 때 사용\n- 특히 통신, 운송, 결제 등의 방식을 설명할 때 자주 사용\n- 공식적인 비즈니스 맥락에서 자주 사용되는 표현",
    translation: "최종 결제는 3월 15일까지 전신 송금을 통해 처리되어야 합니다.",
    type: "preposition phrase",
  },
  {
    id: 32,
    koreanQuestion:
      "회사는 (현재) 성공적으로 절감했다 운영 비용을 자동화 및 프로세스 최적화____",
    question:
      "The company has successfully reduced operational costs ___ automation and process optimization.",
    choices: {
      A: "by means of",
      B: "by way of",
      C: "via",
      D: "owing to",
    },
    correctAnswer: "A",
    explanation:
      "설명:\n\nA: by means of는 '~을 통해, ~을 수단으로'라는 의미로 자동화와 프로세스 최적화를 통한 비용 절감을 설명하는데 가장 적절\nB: by way of는 '경유하여'라는 의미로 특정 방법을 강조하는 문맥과 맞지 않음\nC: via는 '경유하여, ~을 통해'라는 의미는 가능하지만 격식적인 문장에서는 'by means of'가 더 적절\nD: owing to는 '~때문에'라는 원인 설명이므로 부적절\n\n✅ by means of 사용:\n- '~을 수단으로 하여, ~을 통해'라는 의미로 특정 방법이나 수단을 강조할 때 사용\n- 공식적이고 격식 있는 표현으로 비즈니스 문맥에서 적절\n- 특히 구체적인 방법이나 수단을 설명할 때 효과적",
    translation:
      "회사는 자동화 및 프로세스 최적화를 통해 운영 비용을 성공적으로 절감했다.",
    type: "preposition phrase",
  },
  {
    id: 33,
    koreanQuestion: "회사는 계속했다 운영을 심각한 경제 침체 ____ ",
    question:
      "The company continued operations ___ the severe economic downturn.",
    choices: {
      A: "despite",
      B: "owing to",
      C: "in the wake of",
      D: "by means of",
    },
    correctAnswer: "A",
    explanation:
      "설명:\n\nA: despite는 '~에도 불구하고'라는 의미로 어려운 상황에서도 운영을 지속했다는 문맥에 가장 적절\nB: owing to는 '~때문에'라는 의미로 부정적 상황에서의 지속을 나타내는 문맥과 맞지 않음\nC: in the wake of는 '~의 결과로'라는 의미로 경제 침체 상황에서의 지속을 나타내는 문맥과 맞지 않음\nD: by means of는 '~을 통해'라는 의미로 수단을 나타내므로 부적절\n\n✅ despite 사용:\n- '~에도 불구하고'라는 의미로 역접의 상황을 나타낼 때 사용\n- 부정적인 상황이나 장애물에도 불구하고 행동이 계속됨을 강조\n- despite + 명사구의 형태로 사용되는 전형적인 표현",
    translation: "회사는 심각한 경제 침체에도 불구하고 운영을 계속했다.",
    type: "preposition phrase",
  },
  {
    id: 34,
    koreanQuestion:
      "공급업체는 동의했다 제공하는 것을 추가 지원을 상호 합의된 조건 ____ .",
    question:
      "The supplier agrees to provide additional support ___ mutually agreed-upon terms.",
    choices: {
      A: "beyond",
      B: "under",
      C: "throughout",
      D: "over",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\nA: beyond는 '~을 넘어서'라는 의미로 조건을 나타내는 문맥과 맞지 않음\nB: under는 '~의 조건 하에서'라는 의미로 합의된 조건을 나타내는데 가장 적절\nC: throughout는 '~동안 줄곧'이라는 의미로 조건을 나타내는 문맥과 맞지 않음\nD: over는 '~위에'라는 의미로 조건을 나타내는데 부적절\n\n✅ under 사용:\n- '~의 조건 하에서, ~에 따라'라는 의미로 특정 조건이나 규칙을 나타낼 때 사용\n- 계약, 합의, 규정 등과 관련된 비즈니스 문맥에서 자주 사용\n- 공식적인 문서나 계약서에서 흔히 볼 수 있는 표현",
    translation:
      "공급업체는 상호 합의된 조건 하에서 추가 지원을 제공하기로 동의했다.",
    type: "preposition phrase",
  },
  {
    id: 35,
    koreanQuestion:
      "회사는 이뤘다 상당한 성장을 전략적 합병 그리고 인수들____  지난 10년 동안",
    question:
      "The company achieved substantial growth ___ strategic mergers and acquisitions over the past decade.",
    choices: {
      A: "following",
      B: "rather than",
      C: "through",
      D: "in lieu of",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\nA: following은 '이후에'라는 의미로 성장의 방법을 나타내는 문맥과 맞지 않음\nB: rather than은 '대신에'라는 의미로 방법을 설명하는 문장에서 부적절\nC: through는 '~을 통해'라는 의미로 성장 수단을 나타내는데 가장 적절\nD: in lieu of는 '대신에'라는 의미로 성장 수단을 강조하는 문맥과 맞지 않음\n\n✅ through 사용:\n- '~을 통해'라는 의미로 특정 방법이나 수단을 나타낼 때 사용\n- 비즈니스 문맥에서 전략이나 방법을 설명할 때 자주 사용\n- 특히 성과나 결과를 달성하는 수단을 강조할 때 효과적",
    translation:
      "회사는 지난 10년 동안 전략적 인수합병을 통해 상당한 성장을 이뤘다.",
    type: "preposition phrase",
  },
  {
    id: 36,
    koreanQuestion:
      "성공적인 제품 출시___ ,  회사는 계획한다 확장하는 것을 국제 시장으로 ",
    question:
      "___ the successful product launch, the company plans to expand into international markets.",
    choices: {
      A: "Through",
      B: "Following",
      C: "Rather than",
      D: "In the wake of",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\nA: Through는 '~을 통해'라는 의미로 방법을 나타내므로 '이후에'라는 의미와 맞지 않음\nB: Following은 '~이후에'라는 의미로 제품 출시 후의 계획을 나타내는데 가장 적절\nC: Rather than은 '~대신에'라는 의미로 이후에 일어난 결과를 설명하는 문맥과 부적절\nD: In the wake of는 '~의 여파로'라는 의미로 쓰일 수 있지만, 중립적인 의미에서 단순히 '이후'를 나타내는 문맥에는 Following이 더 적절\n\n✅ Following 사용:\n- '~이후에'라는 의미로 시간적 순서를 나타낼 때 사용\n- 특히 비즈니스 문맥에서 어떤 사건이나 행동 이후의 결과나 계획을 설명할 때 자주 사용\n- 중립적이고 전문적인 어조를 유지할 때 선호되는 표현",
    translation:
      "성공적인 제품 출시 이후, 회사는 국제 시장으로 확장을 계획하고 있다.",
    type: "preposition phrase",
  },
  {
    id: 37,
    koreanQuestion:
      "회사는 결정했다 집중하기로 개발하는 것에 혁신적 소프트웨어 솔루션 진입하는것_____ 매우 경쟁이 치열한 하드웨어 시장에",
    question:
      "The company decided to focus on developing innovative software solutions ___ entering the highly competitive hardware market.",
    choices: {
      A: "following",
      B: "through",
      C: "rather than",
      D: "despite",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\nA: following은 '이후에'라는 의미로 선택을 비교하는 문맥과 맞지 않음\nB: through는 '~을 통해'라는 의미로 선택의 비교를 나타내는 문맥과 맞지 않음\nC: rather than은 'A보다는 B'라는 의미로 두 선택지 간의 비교를 나타내는데 가장 적절\nD: despite는 '~에도 불구하고'라는 의미로 선택을 강조하는 문장에서 부적절\n\n✅ rather than 사용:\n- 'A보다는 B'라는 의미로 두 가지 선택지를 비교할 때 사용\n- 비즈니스 결정이나 전략적 선택을 설명할 때 자주 사용되는 표현\n- 특히 한 옵션을 다른 옵션보다 선호한다는 것을 명확히 할 때 효과적",
    translation:
      "회사는 경쟁이 치열한 하드웨어 시장에 진입하는 것보다 혁신적인 소프트웨어 솔루션 개발에 집중하기로 결정했다.",
    type: "preposition phrase",
  },
];

export default conjunctionQuestions;
